import React from 'react';
import './WhatsAppModal.css';
import CloseIcon from '@mui/icons-material/Close';

function WhatsAppModal({ onClose }) {
    return (
        <div className="whatsapp-modal-overlay" onClick={onClose}>
            <div className="whatsapp-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="whatsapp-modal-close-btn" onClick={onClose}>
                    <CloseIcon />
                </button>
                <div className="whatsapp-modal-body">
                    <div className="whatsapp-modal-icon">
                        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="#002654"/>
                        </svg>
                    </div>
                    <h2 className="whatsapp-modal-title">WhatsApp (Coming Soon)</h2>
                    <p className="whatsapp-modal-text">
                        We're currently setting up our official WhatsApp support channel.
                    </p>
                    <p className="whatsapp-modal-text">
                        Soon, you'll be able to connect with <strong>Astra Clean</strong> on WhatsApp for quick support, updates, and special offers.
                    </p>
                    <p className="whatsapp-modal-text">
                        Thank you for your patience and support!
                    </p>
                    <button className="whatsapp-modal-btn" onClick={onClose}>
                        Got it
                    </button>
                </div>
            </div>
        </div>
    );
}

export default WhatsAppModal;
